<template>
  <v-app>
    <v-navigation-drawer v-if="loggedin" app>
      <div
        class="mt-2 ml-7"
        style="height: 60px; display: flex; align-items: center"
      >
        <TenantLogo />
      </div>

      <v-list density="compact" nav class="mt-3">
        <template v-for="item in filteredNavigationOptions" :key="item.title">
          <!-- Regular menu items -->
          <v-list-item
            v-if="!item.submenu"
            :to="item.link"
            @click="handleNavClick(item.link)"
          >
            <template #prepend>
              <v-icon>{{ item.icon }}</v-icon>
            </template>
            <template #default>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
          </v-list-item>

          <!-- Menu items with submenu -->
          <v-list-group v-else :value="item.title">
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <template #prepend>
                  <v-icon>{{ item.icon }}</v-icon>
                </template>
                <template #default>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
              </v-list-item>
            </template>

            <template v-for="subitem in item.submenu" :key="subitem.title">
              <v-list-item
                v-if="!subitem.submenu"
                :to="subitem.link"
                @click="handleNavClick(subitem.link)"
              >
                <template #prepend>
                  <v-icon size="20">{{ subitem.icon }}</v-icon>
                </template>
                <template #default>
                  <v-list-item-title class="text-body-2">{{
                    subitem.title
                  }}</v-list-item-title>
                </template>
              </v-list-item>

              <!-- A group within the submenu (e.g. Instellingen > AI) -->
              <v-list-group
                v-else
                :value="`${item.title}/${subitem.title}`"
                class="nav-subgroup"
              >
                <template #activator="{ props }">
                  <v-list-item v-bind="props">
                    <template #prepend>
                      <v-icon size="20">{{ subitem.icon }}</v-icon>
                    </template>
                    <template #default>
                      <v-list-item-title class="text-body-2">{{
                        subitem.title
                      }}</v-list-item-title>
                    </template>
                  </v-list-item>
                </template>

                <v-list-item
                  v-for="leaf in subitem.submenu"
                  :key="leaf.title"
                  :to="leaf.link"
                  @click="handleNavClick(leaf.link)"
                >
                  <template #default>
                    <v-list-item-title class="text-body-2">{{
                      leaf.title
                    }}</v-list-item-title>
                  </template>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed dark app>
      <v-btn v-if="backVisible" icon variant="text" @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-app-bar-title>{{ tenantStore.tenantDisplayName }}</v-app-bar-title>
      <v-spacer />
      <DeadlineMenu v-if="loggedin && current_user" />
      <NotificationMenu v-if="loggedin && current_user" />
      <ActionCableDebugMenu v-if="loggedin" />
      <VersionInfo v-if="loggedin" />
      <ContextMenu
        v-if="loggedin"
        :options="contextMenuOptions"
        :logout-button="true"
      />
    </v-app-bar>
    <v-main>
      <v-snackbar
        v-if="alert.message"
        v-model="alert.snackbar"
        :color="alert.type"
        :timeout="alert.timeout"
        top
      >
        {{ alert.message }}
        <template #actions>
          <v-btn color="white" variant="text" @click="alert.snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-container>
        <v-alert
          v-if="
            loggedin &&
            current_user &&
            !current_user.open_day_report &&
            $route.path != '/' &&
            !isDayReportAlertDismissed
          "
          type="info"
          variant="tonal"
          border="start"
          density="compact"
          :closable="true"
          class="mb-4 mx-2 mx-md-0"
          style="border-left-width: 4px !important"
          @click:close="dismissDayReportAlert"
        >
          <template #prepend>
            <v-icon color="info" size="20">mdi-clipboard-alert-outline</v-icon>
          </template>
          <div
            class="d-flex align-center justify-space-between flex-wrap gap-2"
          >
            <div class="text-body-2 flex-grow-1">
              <span class="font-weight-medium">Geen actief dagrapport</span>
              <span class="d-none d-sm-inline">
                - Je kunt geen rapporten toevoegen</span
              >
            </div>
            <v-btn
              color="info"
              variant="elevated"
              size="small"
              density="comfortable"
              to="/"
              class="text-none flex-shrink-0"
            >
              <v-icon start size="16">mdi-plus</v-icon>
              <span class="d-none d-sm-inline">Dagrapport</span>
              <span class="d-sm-none">Nieuw</span>
            </v-btn>
          </div>
        </v-alert>
        <router-view ref="currentView"></router-view>
        <FormHolder />
      </v-container>
    </v-main>
    <v-bottom-navigation
      v-if="loggedin"
      v-model="bottomNav"
      fixed
      grow
      app
      class="d-lg-none"
    >
      <v-btn
        v-for="item in navigation_options_mobile"
        :key="item.title"
        :to="item.link"
        @click="handleNavClick(item.link)"
      >
        <template #default>
          <span>{{ item.title }}</span>
        </template>
        <template #append>
          <v-icon>{{ item.icon }}</v-icon>
        </template>
      </v-btn>
    </v-bottom-navigation>
    <!-- <v-footer app> -->

    <!-- </v-footer> -->
  </v-app>
</template>

<script>
import ContextMenu from "./components/ui/ContextMenu.vue";
import NotificationMenu from "./components/notifications/NotificationMenu.vue";
import FormHolder from "./components/ui/FormHolder.vue";
import DeadlineMenu from "./components/deadlines/DeadlineMenu.vue";
import { useAuthStoreRefactor } from "./stores/authStoreRefactor";
import { useAlertStore } from "./stores/alertStore";
import { useMenuStore } from "./stores/menuStore";
import { useContextMenuStore } from "./stores/contextMenuStore";
import { useNotificationsStoreRefactor } from "./stores/notificationsStoreRefactor";
import { ref, watch } from "vue";
import { useUsersStoreRefactor } from "./stores/usersStoreRefactor";
import { useTraitsStoreRefactor } from "./stores/traitsStoreRefactor";
import { useDeadlinesStoreRefactor } from "./stores/deadlinesStoreRefactor";
import { useDayReportTypesStoreRefactor } from "./stores/dayReportTypesStoreRefactor";
import { useAccountsStoreRefactor } from "./stores/accountsStoreRefactor";
import { useAccountLeadsStoreRefactor } from "./stores/accountLeadsStoreRefactor";
import { useAccountCategoriesStoreRefactor } from "./stores/accountCategoriesStoreRefactor";
import { useReportsStoreRefactor } from "./stores/reportsStoreRefactor";
import { useCommentsStoreRefactor } from "./stores/commentsStoreRefactor";
import VersionInfo from "./components/ui/VersionInfo.vue";
import TenantLogo from "./components/TenantLogo.vue";
import { useTenantStore } from "./stores/tenantStore";
import ActionCableDebugMenu from "./components/ui/ActionCableDebugMenu.vue";
import { filterNavigation } from "./utils/navigation";

export default {
  name: "App",
  components: {
    ContextMenu,
    NotificationMenu,
    FormHolder,
    DeadlineMenu,
    VersionInfo,
    TenantLogo,
    ActionCableDebugMenu,
  },
  setup() {
    const authStore = useAuthStoreRefactor();
    const alertStore = useAlertStore();
    const menuStore = useMenuStore();
    const contextMenuStore = useContextMenuStore();
    const notificationsStore = useNotificationsStoreRefactor();
    const commentsStore = useCommentsStoreRefactor();
    const reportsStore = useReportsStoreRefactor();
    const usersStore = useUsersStoreRefactor();
    const tenantStore = useTenantStore();
    const currentView = ref(null);

    // Watch route changes
    watch(
      () => window.location.pathname,
      () => {
        if (contextMenuStore) {
          contextMenuStore.reset();
        }
      },
    );

    return {
      currentView,
      authStore,
      alertStore,
      menuStore,
      contextMenuStore,
      notificationsStore,
      commentsStore,
      reportsStore,
      usersStore,
      tenantStore,
    };
  },
  data() {
    return {
      activeBtn: "",
      showNav: "",
      bottomNav: "",
      day_report_alert: "",
      isDayReportAlertDismissed: false,
      publicPages: ["/login"],
      navigation_options: [
        {
          icon: "mdi-briefcase-account-outline",
          title: "Dashboard",
          link: "/",
          show_mobile: true,
        },
        {
          icon: "mdi-account-group",
          title: "DGs",
          link: "/accounts",
          show_mobile: true,
        },
        {
          icon: "mdi-walk",
          title: "Veldwerk",
          link: "/day_reports",
          show_mobile: true,
        },
        {
          icon: "mdi-calendar-month",
          title: "Planning",
          link: "/planner",
          show_mobile: false,
        },
        {
          icon: "mdi-database-export",
          title: "Export",
          link: "/exports",
          show_mobile: false,
        },
        {
          icon: "mdi-account-box-outline",
          title: "Contacten",
          link: "/contacts",
          show_mobile: true,
        },
        {
          icon: "mdi-calendar-check-outline",
          title: "Taken",
          link: "/deadlines",
          show_mobile: false,
        },
        {
          icon: "mdi-account",
          title: "Gebruikers",
          link: "/users",
          show_mobile: false,
        },
        {
          icon: "mdi-cog",
          title: "Instellingen",
          show_mobile: false,
          submenu: [
            {
              icon: "mdi-clipboard-list",
              title: "Dagrapport Types",
              link: "/settings/day-report-types",
            },
            {
              icon: "mdi-domain",
              title: "Tenants",
              link: "/settings/tenants",
            },
            {
              icon: "mdi-shape-outline",
              title: "Categorieën",
              submenu: [
                {
                  title: "Account Categorieën",
                  link: "/settings/account-categories",
                },
                { title: "Account Leads", link: "/settings/account-leads" },
                {
                  title: "Rapportage Categorieën",
                  link: "/settings/report-categories",
                },
                {
                  title: "Deadline Categorieën",
                  link: "/settings/deadline-categories",
                },
                {
                  title: "Contact Categorieën",
                  link: "/settings/contact-categories",
                },
                {
                  title: "Kenmerk Categorieën",
                  link: "/settings/trait-categories",
                },
                { title: "Kenmerken", link: "/settings/traits" },
              ],
            },
            {
              icon: "mdi-robot-outline",
              title: "AI",
              required_role: "admin",
              submenu: [
                { title: "Instructies", link: "/settings/ai" },
                { title: "Modellen", link: "/settings/ai-models" },
                { title: "Gebruik en kosten", link: "/settings/ai-usage" },
                { title: "Aanvragen", link: "/settings/ai-requests" },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    navigation_options_mobile() {
      const mobileOptions = [];

      this.filteredNavigationOptions.forEach((item) => {
        if (item.show_mobile) {
          if (item.submenu) {
            // For items with submenu, add the submenu items to mobile nav
            item.submenu.forEach((subitem) => {
              mobileOptions.push(subitem);
            });
          } else {
            // Regular items
            mobileOptions.push(item);
          }
        }
      });

      return mobileOptions;
    },
    current_user() {
      return this.authStore.user;
    },
    backVisible() {
      return this.menuStore.backActive;
    },
    alert() {
      return this.alertStore;
    },
    loggedin() {
      return this.authStore.status.loggedIn;
    },
    contextMenuOptions() {
      return this.contextMenuStore.options;
    },
    filteredNavigationOptions() {
      return filterNavigation(
        this.navigation_options,
        this.authStore.user?.roles || [],
      );
    },
  },
  async mounted() {
    // Initialize all stores when the component is mounted
    console.log("App.vue: Component mounted, initializing stores...");
    await this.initializeData();

    // Prevent pinch-to-zoom behavior
    this.preventZoom();
  },
  methods: {
    async initializeData() {
      console.log("App: Initializing all stores");

      if (this.authStore.token) {
        try {
          await this.authStore.getCurrentUser();

          if (this.authStore.user) {
            console.log("App: User authenticated, initializing all stores");

            // Get ALL stores (consistent naming)
            const usersStore = useUsersStoreRefactor();
            const traitsStore = useTraitsStoreRefactor();
            const deadlinesStore = useDeadlinesStoreRefactor();
            const dayReportTypesStore = useDayReportTypesStoreRefactor();
            const accountCategoriesStore = useAccountCategoriesStoreRefactor();
            const accountLeadsStore = useAccountLeadsStoreRefactor();
            const notificationsStore = useNotificationsStoreRefactor();
            const accountsStore = useAccountsStoreRefactor();
            const commentsStore = useCommentsStoreRefactor();
            const reportsStore = useReportsStoreRefactor();

            // Phase 1: Initialize ActionCable for stores that need real-time updates
            console.log("🔌 Phase 1: Initializing ActionCable connections...");
            await Promise.all([
              accountsStore.init(),
              deadlinesStore.init(),
              usersStore.init(),
              commentsStore.init(),
              reportsStore.init(),
              notificationsStore.init(),
            ]);

            // Phase 2: Load all store data
            console.log("📊 Phase 2: Loading all store data...");
            const results = await Promise.allSettled([
              // Stores with ActionCable (may use cached data)
              deadlinesStore.getAll(),
              usersStore.fetchAll(),
              notificationsStore.fetchAll(),

              // Stores without ActionCable (fresh data)
              traitsStore.fetchAll(),
              dayReportTypesStore.getAll(),
              accountCategoriesStore.getAll(),
              accountLeadsStore.getAll(),
            ]);

            // Log results for debugging
            const storeNames = [
              "Deadlines",
              "Users",
              "Notifications",
              "Traits",
              "DayReportTypes",
              "AccountCategories",
              "AccountLeads",
            ];

            results.forEach((result, index) => {
              if (result.status === "fulfilled") {
                console.log(
                  `✅ ${storeNames[index]} store loaded successfully`,
                );
              } else {
                console.error(
                  `❌ ${storeNames[index]} store failed:`,
                  result.reason,
                );
              }
            });

            console.log("🎉 All stores initialized and data loaded");
          }
        } catch (error) {
          console.error("❌ Error initializing stores:", error);
        }
      }
    },

    logOut() {
      this.authStore.logout();
      this.$router.push("/login");
    },
    handleNavClick(link) {
      this.$router.push(link);
    },
    handleImageError(error) {
      console.error("Error loading logo image:", error);
      // Try to load a fallback image
      if (error && error.target) {
        error.target.src = "/img/icons/android-chrome-192x192.png";
      }
    },

    // Dismiss the day report alert for the current session
    dismissDayReportAlert() {
      this.isDayReportAlertDismissed = true;
    },

    // Prevent pinch zoom on mobile and desktop
    preventZoom() {
      // Prevent ctrl+wheel zoom on desktop
      window.addEventListener(
        "wheel",
        (e) => {
          if (e.ctrlKey) {
            e.preventDefault();
          }
        },
        { passive: false },
      );

      // Variables to track touch events for pinch detection
      let lastTouchEnd = 0;
      let touchStartCount = 0;

      // Handle touchstart to detect multi-finger gestures
      document.addEventListener(
        "touchstart",
        (e) => {
          touchStartCount = e.touches.length;
          if (touchStartCount > 1) {
            e.preventDefault();
          }
        },
        { passive: false },
      );

      // Handle touchend to prevent quick double-tap zoom
      document.addEventListener(
        "touchend",
        (e) => {
          const now = Date.now();
          if (now - lastTouchEnd <= 300) {
            e.preventDefault();
          }
          lastTouchEnd = now;
        },
        { passive: false },
      );

      // Prevent gesturestart (specific to Safari)
      document.addEventListener(
        "gesturestart",
        (e) => {
          e.preventDefault();
        },
        { passive: false },
      );
    },
  },
};
</script>

<style>
@import "./assets/styles/styles.css";
.container {
  padding: 6px !important;
}

/* 📱 MOBILE-ONLY: Reduce main container padding from 16px to 8px */
@media (max-width: 599px) {
  .v-container {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

/* Navigation drawer: Vuetify indents every nested level by a full icon column,
   which leaves too little room for the titles. Keep the levels close together. */
.v-navigation-drawer .v-list-group__items .v-list-item {
  padding-inline-start: 28px !important;
}
.v-navigation-drawer
  .v-list-group__items
  .v-list-item__prepend
  > .v-icon
  ~ .v-list-item__spacer {
  width: 16px;
}
.v-navigation-drawer .nav-subgroup .v-list-group__items .v-list-item {
  /* lines up with the titles of the level above (28px + icon + spacer) */
  padding-inline-start: 64px !important;
}
</style>
